import CXMApiClient from "../../CXMApiClient";
import { HelperFunctions } from "../../../lib/utilities/HelperFunctions";
import { ChildFilter } from "@/lib/utilities/enums.js";
import { delayTypes, delayTypesName } from "../../../lib/utilities/enums";

function convertAPIResponse(ruleInfo, context) {
  let users = context.getters.appUsers;
  let groups = context.getters.SalesGroups;
  let status = context.getters.RuleTaskStatus;
  let leadStatus = context.getters.RuleLeadStatus;
  let roles = context.getters.AlertMinerRoles;

  if (ruleInfo.triggerSetTasks.length > 0) {
    ruleInfo.triggerSetTasks
      .map(m => m.triggerSetTaskNotifications)
      .reduce((a, b) => {
        return a.concat(b);
      })
      .forEach(e => {
        if (
          e.userIds.length > 0 &&
          typeof e.userIds === "object" &&
          typeof e.userIds[0] === "string"
        ) {
          e.userIds = users.filter(f => e.userIds.includes(f.userId));
        }
        if (typeof e.groupId === "string") {
          e.groupId = groups.find(f => f.Id === e.groupId) || "";
        }
        if (typeof e.roleId === "number") {
          e.roleId = roles.find(f => f.Id == e.roleId) || "";
        }

        if (typeof e.onEvent === "object") {
          e.onEvent = status.find(f => f.value == e.onEvent.value);
        } else {
          e.onEvent = status.find(f => f.value == e.onEvent);
        }
      });
  }
  if (
    ruleInfo.triggerSetNotifications &&
    ruleInfo.triggerSetNotifications.length > 0
  ) {
    ruleInfo.triggerSetNotifications.forEach(e => {
      if (
        e.userIds.length > 0 &&
        typeof e.userIds === "object" &&
        typeof e.userIds[0] === "string"
      ) {
        e.userIds = users.filter(f => e.userIds.includes(f.userId));
      }
      if (typeof e.groupId === "string") {
        e.groupId = groups.find(f => f.Id === e.groupId) || "";
      }
      if (typeof e.roleId === "number") {
        e.roleId = roles.find(f => f.Id == e.roleId) || "";
      }
      if (typeof e.onEvent === "object") {
        e.onEvent = leadStatus.find(f => f.value == e.onEvent.value);
      } else {
        e.onEvent = leadStatus.find(f => f.value == e.onEvent);
      }
    });
  }
  if (ruleInfo.triggerSetFilters && ruleInfo.triggerSetFilters.length > 0) {
    ruleInfo.triggerSetFilters.forEach(filter => {
      let type = HelperFunctions.getFilterInputType(
        filter.filterId,
        context.getters.FilterTypes
      );
      filter.isBoolType = type && type == "bool";
      if (filter.isBoolType) filter.filterValue = filter.filterValue == "true";

      if (filter.filterId == ChildFilter.Stock && filter.filterValue) {
        let savedStockItems = HelperFunctions.parseStringToJSON(
          filter.filterValue
        );
        if (savedStockItems && savedStockItems.length > 0) {
          filter.filterValue = savedStockItems.join(",");
        }
      }
      if (filter.filterValue) {
        if (type == "int" || type == "filterswithduration") {
          filter.filterValue = parseInt(filter.filterValue);
        }
        if (type == "float") {
          {
            filter.filterValue = parseFloat(filter.filterValue);
          }
        }
      }
      filter.selectedDurationDelayType = null;
      if (filter.filterId == ChildFilter.TimeSinceDealEnd) {
        filter.selectedDurationDelayType = filter.filterValue
          ? Math.sign(filter.filterValue) < 0
            ? delayTypes.find(x => x.id == delayTypesName.Before)
            : delayTypes.find(x => x.id == delayTypesName.After)
          : null;
        filter.filterValue = Math.abs(filter.filterValue);
      }
    });
  }

  return ruleInfo;
}

function convertRequestPayload(ruleInfo, context) {
  ruleInfo = JSON.parse(JSON.stringify(ruleInfo));
  // If new rule
  if (ruleInfo.id < 0) {
    delete ruleInfo.id;
    ruleInfo.createdt = new Date();
    ruleInfo.createuser = context.getters.User.Id;
  } else {
    // If existing rule
    ruleInfo.updatedt = new Date();
    ruleInfo.updateuser = context.getters.User.Id;
  }

  if (
    isNaN(ruleInfo.accountPlatformIds[0]) ||
    typeof ruleInfo.accountPlatformIds[0] === "object"
  ) {
    ruleInfo.accountPlatformIds = ruleInfo.accountPlatformIds.map(
      m => m.accountPlatformID
    );
  }

  for (let i = 0; i < ruleInfo.triggerSetTasks.length; i++) {
    if (ruleInfo.triggerSetTasks[i].triggerSetTaskId < 0) {
      delete ruleInfo.triggerSetTasks[i].triggerSetTaskId;
      delete ruleInfo.triggerSetTasks[i].triggerSetId;
      ruleInfo.triggerSetTasks[i].createdt = new Date();
      ruleInfo.triggerSetTasks[i].createuser = context.getters.User.Id;
    } else {
      ruleInfo.triggerSetTasks[i].updatedt = new Date();
      ruleInfo.triggerSetTasks[i].updateuser = context.getters.User.Id;
    }

    ruleInfo.triggerSetTasks[i].terminators = ruleInfo.triggerSetTasks[
      i
    ].terminators.filter(
      f => f.activityTypeId !== null && f.activityTypeId !== 0
    );
    ruleInfo.triggerSetTasks[i].triggerSetTaskNotifications = ruleInfo
      .triggerSetTasks[i].triggerSetTaskNotifications
      ? ruleInfo.triggerSetTasks[i].triggerSetTaskNotifications.filter(
        f => !(f.triggerSetTaskNotificationId < 0 && f.Deleted)
      )
      : [];
    ruleInfo.triggerSetTasks[i].triggerSetTaskNotifications.forEach(e => {
      if (e.triggerSetTaskNotificationId < 0) {
        delete e.triggerSetTaskNotificationId;
      }
      if (e.userIds.length > 0) {
        e.userIds = e.userIds.map(m => m.userId);
      }
      if (!!e.groupId && typeof e.groupId === "object") {
        e.groupId = e.groupId.Id;
      }
      if (!!e.roleId && typeof e.roleId === "object") {
        e.roleId = parseInt(e.roleId.Id);
      }
      if (e.onEvent && e.onEvent.value) {
        e.onEvent = parseInt(e.onEvent.value);
      }
    });
  }

  ruleInfo.triggers = ruleInfo.triggers.filter(
    f => f.activityTypeId !== null && f.activityTypeId !== 0
  );
  ruleInfo.terminators = ruleInfo.terminators.filter(
    f => f.activityTypeId !== null && f.activityTypeId !== 0
  );

  ruleInfo.triggerSetNotifications.forEach(e => {
    if (e.triggerSetNotificationId < 0) {
      delete e.triggerSetNotificationId;
    }
    if (e.userIds.length > 0) {
      e.userIds = e.userIds.map(m => m.userId);
    }
    if (!!e.groupId && typeof e.groupId === "object") {
      e.groupId = e.groupId.Id;
    }
    if (!!e.roleId && typeof e.roleId === "object") {
      e.roleId = parseInt(e.roleId.Id);
    }
    e.onEvent = parseInt(e.onEvent.value);
  });

  return ruleInfo;
}

const state = {
  RuleDetail: {},
  LoadingRuleDetail: false,
  ModifiedRuleDetail: false,
  RuleChangesModal: {
    ShowModal: false,
    SuccessHandler: null,
    SuccessHandlerData: null
  },
  CurrentVehicleInfoList: [],
  ReplacementVehicleInfoList: [],
  TradeInVehicleInfoList: [],
  VoiVehicleInfoList: []
};

const getters = {
  CurrentVehicleInfoList: function () {
    return state.CurrentVehicleInfoList;
  },
  ReplacementVehicleInfoList: function () {
    return state.ReplacementVehicleInfoList;
  },
  TradeInVehicleInfoList: function () {
    return state.TradeInVehicleInfoList;
  },
  VoiVehicleInfoList: function () {
    return state.VoiVehicleInfoList;
  }
};

const actions = {
  getRuleDetailById(context, ruleId) {
    context.commit("clearRuleDetail");
    return new Promise((resolve, reject) => {
      context.commit("updateLoadingRuleDetail", true);
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", `/api/triggerset/${ruleId}`)
        .then(resp => {
          context.commit("updateLoadingRuleDetail", false);
          if (resp && resp.data) {
            if (resp.data.data) {
              let ruleInfo = convertAPIResponse(resp.data.data, context);

              context.commit("gotRuleDetail", ruleInfo);
              resolve(resp.data);
            } else {
              context.commit("gotRuleDetail", null);
              reject(resp.data);
            }
          }
        })
        .catch(resp => {
          context.commit("updateLoadingRuleDetail", false);
          context.commit("gotRuleDetail", null);
          reject(resp);
        });
    });
  },
  addNewRule(context, ruleInfo) {
    context.commit("clearRuleDetail");
    context.commit("addNewRule", ruleInfo);
  },
  async saveRule(context, ruleInfo) {
    ruleInfo = convertRequestPayload(ruleInfo, context);

    let client = new CXMApiClient();
    const response = await client.ProcessRequest("post", "/api/TriggerSet", JSON.stringify(ruleInfo)).catch(err => err.response);
    if (response.data && response.data.successful) {
      const ruleInfo = convertAPIResponse(response.data.data, context);
      context.commit("gotRuleDetail", ruleInfo);
    }
    return response;
  },
  clearRuleDetail(context) {
    context.commit("clearRuleDetail");
  },
  setRuleDetailModified(context, value) {
    context.commit("setRuleDetailModified", value);
  },
  openRuleChangesModal(context, data) {
    context.commit("openRuleChangesModal", data);
  },
  closeRuleChangesModal(context) {
    context.commit("closeRuleChangesModal");
  },
  getRulesSeedStatusByType(context, data) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "GET",
          `/api/rulegroup/accountplatform/${data.PlatformId}/${data.Type}`
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  requestRulesReseedByType(context, data) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/rulegroup/accountplatform/${data.PlatformId}/${data.Type}`
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  updateCurrentVehicleInfoList: function (context, data) {
    context.commit("updateCurrentVehicleInfoList", data);
  },
  updateReplacementVehicleInfoList: function (context, data) {
    context.commit("updateReplacementVehicleInfoList", data);
  },
  updateTradeInVehicleInfoList: function (context, data) {
    context.commit("updateTradeInVehicleInfoList", data);
  },
  updateVoiVehicleInfoList: function (context, data) {
    context.commit("updateVoiVehicleInfoList", data);
  }
};

const mutations = {
  gotRuleDetail(state, data) {
    state.RuleDetail = data;
  },
  addNewRule(state, ruleInfo) {
    state.RuleDetail = {
      id: 0,
      accountId: ruleInfo.accountId,
      accountPlatformIds: ruleInfo.accountPlatformIds,
      ruleGroupId: ruleInfo.ruleGroupId,
      isNewRule: true,
      leadTypeId: 1, //px-3671 changing to be sales
      name: "",
      description: "",
      triggers: [],
      terminators: [],
      enabled: false,
      rank: 0,
      deleted: false,
      triggerSetTasks: [],
      triggerSetNotifications: [],
      triggerSetFilters: [],
      vehicles: []
    };
  },
  clearRuleDetail(state) {
    state.RuleDetail = null;
    state.LoadingRuleDetail = false;
    state.ModifiedRuleDetail = false;
    state.CurrentVehicleInfoList = [];
    state.ReplacementVehicleInfoList = [];
    state.TradeInVehicleInfoList = [];
    state.VoiVehicleInfoList = [];
    state.StockItems = "";
  },
  updateLoadingRuleDetail(state, value) {
    state.LoadingRuleDetail = value;
  },
  setRuleDetailModified(state, value) {
    state.ModifiedRuleDetail = value;
  },
  openRuleChangesModal(state, data) {
    state.RuleChangesModal.SuccessHandler = data.SuccessHandler;
    state.RuleChangesModal.SuccessHandlerData = data.SuccessHandlerData;
    state.RuleChangesModal.ShowModal = true;
  },
  closeRuleChangesModal(state) {
    state.RuleChangesModal.SuccessHandler = null;
    state.RuleChangesModal.SuccessHandlerData = null;
    state.RuleChangesModal.ShowModal = false;
  },
  updateCurrentVehicleInfoList: function (state, data) {
    if (data && data.length > 0) {
      data.forEach(filter => {
        if (!filter.Id) filter.Id = moment().valueOf();
      });
    }
    state.CurrentVehicleInfoList = data;
  },
  updateReplacementVehicleInfoList: function (state, data) {
    if (data && data.length > 0) {
      data.forEach(filter => {
        if (!filter.Id) filter.Id = moment().valueOf();
      });
    }
    state.ReplacementVehicleInfoList = data;
  },
  updateVoiVehicleInfoList: function (state, data) {
    if (data && data.length > 0) {
      data.forEach(filter => {
        if (!filter.Id) filter.Id = moment().valueOf();
      });
    }
    state.VoiVehicleInfoList = data;
  },
  updateTradeInVehicleInfoList: function (state, data) {
    if (data && data.length > 0) {
      data.forEach(filter => {
        if (!filter.Id) filter.Id = moment().valueOf();
      });
    }
    state.TradeInVehicleInfoList = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/rules/RuleDetail.js